import { BasePolyfill } from './BasePolyfill';

class ScrollBehaviorPolyfill extends BasePolyfill {
  public execute = !('scrollBehavior' in document.documentElement.style);
  public polyfill = () => {
    return new Promise((resolve, reject) => {
      import('smoothscroll-polyfill')
        .then((x) => {
          x.default.polyfill();
          resolve(x);
        })
        .catch(reject);
    });
  }
}

export { ScrollBehaviorPolyfill };
